export const searchFields = [
  'title',
  'description',
  'category',
  'authorName',
  'datePublication',
  'linkArticle',
  'tags',
  'authorTitle',
  'contentLead',
  'contentTop',
  'contentMediaCaption',
  'contentMiddle',
  'contentQuote',
  'contentBottom',
]

export const fuseOptions = {
  includeScore: true,
  includeMatches: true,
  threshold: 0.2,
  caseSensitive: false,
  location: 0,
  distance: 10000,
  ignorelocation: true,
  useExtendedSearch: true,
  keys: searchFields,
}
